import styled from "styled-components";

export const ModalSection = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #00000061;
  z-index: 500;
`;

export const Modal = styled.div`
  width: calc(100vw * (272 / 375));
  height: fit-content;
  background: white;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  border-radius: 18px;
  display: flex;
  flex-flow: column;
`;

export const HeaderImgSection = styled.div`
  max-height: calc(100vw * (130 / 375));
  max-width: calc(100vw * (199 / 375));
  padding-top: calc(100vw * (16 / 375));
  margin: 0 auto;
  flex: 0 1 auto;
  box-sizing: content-box;
  margin-bottom: calc(100vw * (13 / 375));
`;

export const HeaderImg = styled.img``;

export const BodySection = styled.div`
  flex: 1 1 auto;
  height: fit-content;
`;

export const ModalInfo = styled.div`
  text-align: center;
  margin-bottom: calc(100vw * (23 / 375));
`;

export const InfoTitle = styled.div`
  font-weight: bold;
  font-size: calc(100vw * (16 / 375));
  line-height: calc(100vw * (23 / 375));
  margin-bottom: calc(100vw * (10 / 375));
  word-break: keep-all;
`;

export const InfoDescription = styled.div`
  font-size: calc(100vw * (14 / 375));
  line-height: calc(100vw * (20 / 375));
  white-space: pre-wrap;
`;

export const BtnDummySpace = styled.div`
  height: calc(100vw * (53 / 375));
`;

export const BtnSection = styled.div`
  position: relative;
  height: calc(100vw * (53 / 375));
  position: absolute;
  bottom: 0;
  width: 100%;
  z-index: 50;
  &:after {
    clear: both;
    display: block;
    content: " ";
  }
`;

export const ModalBtn = styled.div`
  height: calc(100vw * (53 / 375));
  line-height: calc(100vw * (53 / 375));
  width: 50%;
  float: left;
  text-align: center;
  font-size: calc(100vw * (14 / 375));
  overflow: hidden;
`;

export const LeftBtn = styled(ModalBtn)`
  background: #f7f7f7;
  font-weight: bold;
  border-bottom-left-radius: 18px;
`;

export const RightBtn = styled(ModalBtn)`
  background: #ffcf19;
  font-weight: bold;
  border-bottom-right-radius: 18px;
`;
